export const DEVICE_FINGERPRINT_COOKIE = "_se_t";
